export const APPEARANCE = {
  HUMANOID: "humanoid",
  QUADRUPED: "quadruped/sextuped",
  SERPENTINE: "serpentine",
};

export const appearance = Object.keys(APPEARANCE);
